var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2301 6.95455C14.3959 7.16127 14.4877 7.42984 14.4877 7.70831C14.4877 7.98678 14.3959 8.25535 14.2301 8.46207C13.1801 9.73334 10.7901 12.2084 8.00009 12.2084C5.21009 12.2084 2.82009 9.73334 1.77009 8.46207C1.60425 8.25535 1.51245 7.98678 1.51245 7.70831C1.51245 7.42984 1.60425 7.16127 1.77009 6.95455C2.82009 5.68328 5.21009 3.20825 8.00009 3.20825C10.7901 3.20825 13.1801 5.68328 14.2301 6.95455Z",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.7083C9.10457 9.7083 10 8.81287 10 7.7083C10 6.60373 9.10457 5.7083 8 5.7083C6.89543 5.7083 6 6.60373 6 7.7083C6 8.81287 6.89543 9.7083 8 9.7083Z",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowpassword);
export default __webpack_public_path__ + "static/media/showpassword.6b3e4e23f32846e7a004eb1ec062110a.svg";
export { ForwardRef as ReactComponent };